<template>
  <FormPto
    v-model="modelFormData"
    :is-edit="isEdit"
    :is-sending="isSending"
    :clear-on-destroy="!isEdit"
    @request="onSubmit"
    @cancel="onCancel"
  >
    <PTOProjectTitle v-if="isEdit" is-edit />

    <VInput
      label="№ ведомости"
      name="number"
      required
    >
      <Validation for="required">Поле обязательно</Validation>
    </VInput>

    <VSelect
      label="Тип"
      name="type"
      :items="statementTypeList"
      :handler-search="GETStatementTypeList"
      search
    />

    <VInput
      label="Письмо Интекс"
      name="intex_letter"
    />

    <AppInputDate
      title="Дата создания ведомости"
      name="create_date"
      type="single"
    />

    <VInput
      label="Письмо Заказчика"
      name="customer_letter"
    />

    <VInput
      label="Письмо подрядчика"
      name="contractor_letter"
    />

    <VSelect
      v-if="hasEstimates"
      :value="modelFormData.estimates"
      label="№ сметы"
      :items="[]"
      item-text="estimate"
      multiple
      disabled
    />

    <VCheckbox
      v-if="!hasEstimates"
      :value="!hasEstimates"
      :checked="!hasEstimates"
      title="Отсутствует смета"
      class="form__checkbox-wrap"
      disabled
    />

    <VSelectJob
      label="Добавить работы"
      name="jobs"
      :items="projectPTOJobList"
      :handler-search="GETProjectPTOJobList"
      class="form__input--col-2"
    />

    <AppInputFile
      title="Загрузите файл"
      class="form__input--col-2"
      name="files"
      @delete-file="ADD_FILE_TO_DELETE"
    />

    <VInput
      label="Примечание"
      class="form__input--col-2"
      name="note"
      type="textarea"
    />
  </FormPto>
</template>

<script>
import AppInputDate from '@/components/page/input/AppInputDate'
import AppInputFile from '@/components/page/input/AppInputFile'
import FormPto from '@/components/pto/form/FormPto'
import PTOProjectTitle from '@/components/pto/title/PTOProjectTitle'
import Validation from '@/components/page/Form/Validation.vue'
import VCheckbox from '@/components/page/Form/VCheckbox/VCheckbox'
import VInput from '@/components/page/Form/Vinput/Vinput.vue'
import VSelectJob from '@/components/page/Form/VSelectJob.vue'
import VSelect from '@/components/page/Form/VSelect.vue'

import { MIXIN_FORM_PTO } from '@/mixins/module/pto/mixinFormPto'
import { mixinPtoProjectPTOJobSelect } from '@/mixins/module/pto/mixinPtoProjectPTOJobSelect'

import { mapActions, mapMutations, mapState } from 'vuex'
import { prepareProjectStatementFormData } from '@/utils/page/pto/project'

export default {
  name: 'FormPtoProjectStatement',
  components: {
    AppInputDate,
    AppInputFile,
    FormPto,
    PTOProjectTitle,
    Validation,
    VCheckbox,
    VInput,
    VSelect,
    VSelectJob
  },

  mixins: [
    MIXIN_FORM_PTO,
    mixinPtoProjectPTOJobSelect
  ],

  computed: {
    ...mapState('handbook/pto', {
      statementTypeList: 'statementTypeList'
    }),

    hasEstimates () {
      return Boolean(this.modelFormData?.estimates?.length)
    }
  },

  destroyed () {
    this.RESET_FILES_TO_DELETE()
  },

  methods: {
    ...mapActions('handbook/pto', {
      GETStatementTypeList: 'GETStatementTypeList'
    }),
    ...mapMutations('pto/project/statement', {
      RESET_FILES_TO_DELETE: 'RESET_FILES_TO_DELETE',
      ADD_FILE_TO_DELETE: 'ADD_FILE_TO_DELETE'
    }),

    onSubmit (data) {
      this.$emit('request', prepareProjectStatementFormData(data))
    }
  }
}
</script>
